import type { VehicleShapeDefinition } from './vehicleShape';

/**
 * Coil forklift vehicle
 * Specialized for handling coils with front forks
 */
export const coilForkliftShape: VehicleShapeDefinition = {
  vehicle: 'coil_forklift',
  coordinateSystem: '2D',
  unit: 'normalized_percent',
  polygons: {
    // Front wheels
    front_wheel_left: [
      [15, 20],
      [30, 20],
      [30, 40],
      [15, 40],
    ],

    front_wheel_right: [
      [70, 20],
      [85, 20],
      [85, 40],
      [70, 40],
    ],

    // Rear wheels
    rear_wheel_left: [
      [15, 75],
      [30, 75],
      [30, 95],
      [15, 95],
    ],

    rear_wheel_right: [
      [70, 75],
      [85, 75],
      [85, 95],
      [70, 95],
    ],

    // Main body
    body: [
      [25, 35],
      [75, 35],
      [75, 80],
      [25, 80],
    ],

    // Driver cabin
    cabin: [
      [30, 50],
      [70, 50],
      [70, 75],
      [30, 75],
    ],

    // Fork carriage
    fork_carriage: [
      [30, 15],
      [70, 15],
      [70, 25],
      [30, 25],
    ],

    // Center fork
    fork_center: [
      [46, 0],
      [54, 0],
      [54, 20],
      [46, 20],
    ],
  },
  colorConfig: {
    body: { type: 'dynamic' }, // Uses vehicle color
    front_wheel_left: { type: 'fixed', color: '#000000' },
    front_wheel_right: { type: 'fixed', color: '#000000' },
    rear_wheel_left: { type: 'fixed', color: '#000000' },
    rear_wheel_right: { type: 'fixed', color: '#000000' },
    cabin: { type: 'fixed', color: '#000000' },
    fork_carriage: { type: 'fixed', color: '#000000' },
    fork_center: { type: 'fixed', color: '#000000' },
  },
};
